module.exports = "<ng-container *ngTemplateOutlet=\"metadataTemplate; context: {$implicit: modelContext,formGroup: formGroup}\"></ng-container>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pillar/workspace/components/metadata-form-control/metadata-form-control.component.html
// module id = ./src/app/pillar/workspace/components/metadata-form-control/metadata-form-control.component.html
// module chunks = main